import { motion } from "framer-motion";
import { FadeUp, SectionLabel } from "./Reveal";

const PHASES = [
  {
    num: "01",
    title: "The Foundation",
    body: "Veerox Software is born with a single promise stamped on everything it ships — Built for Success.",
  },
  {
    num: "02",
    title: "The Automation Era",
    body: "WorkAssign and WorkAssign AI bring AI employees to businesses — WhatsApp agents, AI calling and lead automation running 24/7.",
  },
  {
    num: "03",
    title: "The Trading Frontier",
    body: "Forex and More conquers gold scalping with 20,000+ traders, while Veerox Algo pushes autonomous trading intelligence on MT5.",
  },
  {
    num: "04",
    title: "Beyond Technology",
    body: "Dignity Food Kitchen and Being Food carry the same obsession with quality into the real world — real ingredients, real happiness.",
  },
  {
    num: "05",
    title: "Today & Tomorrow",
    body: "Six ventures, one relentless engine — and the next venture is already loading.",
  },
];

export const Journey = () => (
  <section id="journey" data-testid="journey-section" className="relative py-24 md:py-32">
    <div className="pointer-events-none absolute left-0 top-40 h-96 w-96 rounded-full bg-blue-600/10 blur-[150px]" />
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <FadeUp>
        <SectionLabel>The Journey</SectionLabel>
      </FadeUp>
      <FadeUp delay={0.1}>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          From one promise to
          <br />
          <span className="text-gradient-cyan">an empire of ventures.</span>
        </h2>
      </FadeUp>

      <div className="relative mt-16 ml-2">
        <div className="timeline-line absolute left-[7px] top-0 h-full w-[2px]" />
        <div className="space-y-14">
          {PHASES.map((p, i) => (
            <motion.div
              key={p.num}
              data-testid={`journey-phase-${p.num}`}
              initial={{ opacity: 0, x: -28 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="relative pl-12"
            >
              <span className="absolute left-0 top-1.5 h-4 w-4 rounded-full border-2 border-cyan-400 bg-[#020617] shadow-[0_0_14px_rgba(0,229,255,0.7)]" />
              <span className="font-mono-tech text-xs uppercase tracking-[0.26em] text-cyan-400">
                Phase {p.num}
              </span>
              <h3 className="mt-2 font-display text-2xl font-bold tracking-tight text-white md:text-3xl">
                {p.title}
              </h3>
              <p className="mt-3 max-w-2xl text-base leading-relaxed text-slate-400">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
